export default __webpack_public_path__ + "static/media/plain-sticker-or.bc27351f.png";